'use client'
import { useEffect } from 'react'
import posthog from 'posthog-js'
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals'

export function PostHogWebVitals() {
  useEffect(() => {
    if (!process.env.NEXT_PUBLIC_ENABLE_WEB_VITALS) return

    const report = (metric: Metric) => {
      posthog.capture('web_vital', {
        metric: metric.name,
        value: Math.round(metric.value),
        rating: metric.rating,
        path: window.location.pathname,
      })
    }
    onCLS(report)
    onFCP(report)
    onINP(report)
    onLCP(report)
    onTTFB(report)
  }, [])

  return null
}
